import { useState, useEffect } from 'react';
import {
  getSocketInstance,
  emitSubscribeToLobby,
  emitUnsubscribeFromLobby,
  type PublicRoomEntry,
} from './useSocket';

export function usePublicRooms() {
  const [rooms, setRooms] = useState<PublicRoomEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const socket = getSocketInstance();
    if (!socket) return;

    const handleList = (data: { rooms: PublicRoomEntry[] }) => {
      setRooms(data.rooms);
      setLoading(false);
    };

    socket.on('room:publicList', handleList);
    emitSubscribeToLobby();

    return () => {
      socket.off('room:publicList', handleList);
      emitUnsubscribeFromLobby();
    };
  }, []);

  return { rooms, loading };
}
